import { IVariable } from '@models/Forms/IForms';
import { IFieldElem } from '@models/IFormData';
import { getValueString } from '@utils/documentUtils';
import { indirectEval } from '@utils/scriptEval';
import { escapeRegExp } from '@utils/escapeRegExp';
import { substituteFormulaData } from './formulaStringLiteral';

/** Одинаковая подстановка для заголовка карточки и её ссылки в уведомлении. */
export const resolveFormVariable = (variable: IVariable, data: Record<string, IFieldElem>): string | undefined => {
    let result = variable.variableFormat ?? '';
    let condition = variable.condition;
    (variable.fieldVariable ?? []).forEach((field) => {
        let value = getValueString(field.key, data);
        if (field.valueType === 'timestamp') {
            const raw = data[field.key]?.value;
            // Пустая дата — пустая переменная; ошибкой считаем только непустое не-ISO значение.
            if (raw === null || raw === undefined || raw === '') {
                value = '';
            } else {
                if (typeof raw !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})?$/.test(raw)) {
                    throw new Error(`Переменная "${field.variableName}" ожидает ISO-дату в поле "${field.key}".`);
                }
                const timestamp = new Date(raw).getTime();
                if (!Number.isFinite(timestamp)) throw new Error(`Переменная "${field.variableName}" содержит некорректную дату в поле "${field.key}".`);
                value = String(timestamp);
            }
        }
        const replacement = value && field.variableFormat ? field.variableFormat.replace('{value}', () => value) : '';
        const placeholder = `{${field.variableName}}`;
        result = result.replaceAll(placeholder, () => replacement);
        // Условие исполняется как JS: значение поля встаёт литералом, а не кодом.
        if (condition) condition = substituteFormulaData(condition, new RegExp(escapeRegExp(placeholder)), () => ({ value: replacement }));
    });
    return !variable.condition || indirectEval(condition!) ? result : undefined;
};
